import { Reducer } from 'redux';

import { ToastState } from './types';

const defaultState: ToastState = {
    notifications: [],
    isInsidePortal: false,
};

const reducer: Reducer<ToastState> = (state: ToastState = defaultState, action): ToastState => {
    const { payload } = action;

    switch (action.type) {
        case '@@toast/SET':
        case '@@toast/SHOW':
            return {
                ...state,
                notifications: [
                    ...state.notifications,
                    {
                        key: payload.notification.key,
                        message: payload.notification.message,
                        duration: payload.notification.duration,
                        onClose: payload.notification.onClose,
                        severity: payload.notification.severity,
                        width: payload.notification.width,
                    },
                ],
            };
        case '@@toast/HIDE':
            return {
                ...state,
                notifications: state.notifications.filter((notification) => notification.key !== action.payload.key),
            };
        case '@@toast/SET_PORTAL_WRAPPER':
            return {
                ...state,
                isInsidePortal: payload.isInsidePortal,
            };
        default:
            return state;
    }
};

export { reducer as toast };

export default reducer;
